import { Box } from '@mui/material'
import parse, { type DOMNode, Element as DomElement } from 'html-react-parser'
import { SafeImage } from 'shared/ui/atoms/safeImage'
const normalizeHtml = (input: string) => {
	try {
		const parsed = JSON.parse(input)
		if (typeof parsed === 'string')
			return parsed
	} catch {
	}
	return input.replace(/\\"/g, '"')
}

const isDomElement = (node: DOMNode): node is DomElement => {
	return (node as DomElement).name !== undefined && (node as DomElement).attribs !== undefined
}
export const EventDetails = (
	{ details, setIsLinkOpen, setLink }: {
		details?: string | null
		setIsLinkOpen: (v: boolean) => void
		setLink: (link: string | undefined) => void
	}
) => {
	if (!details) return null
	const normalizedDetails = normalizeHtml(`${details}`)

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const target = e.target as HTMLElement

		const link = target.closest('a')

		if (!(link instanceof HTMLAnchorElement)) return

		e.preventDefault()

		setLink(link.href)
		setIsLinkOpen(true)
	}

	return (
		<Box
			onClick={handleClick}
			sx={{
				'fontSize': '24px',
				'& a': {
					color: 'text.accent',
					textDecoration: 'underline'
				},
				'& a:visited': {
					color: 'text.accent'
				}
			}}
		>
			{parse(normalizedDetails, {
				replace: (domNode) => {
					if (isDomElement(domNode) && domNode.name === 'img' && domNode.attribs) {
						return (
							<SafeImage
								src={domNode.attribs['src'] || ''}
								alt={domNode.attribs['alt'] || ''}
							/>
						)
					}
					return undefined
				}
			})}
		</Box>
	)
}
